import apiClient from "../api/api";
import { API_ENDPOINTS } from "../api/api.config";

export interface DocumentItem {
  _id: string;
  name: string;
  file_type: string;
  file_size: number;
  upload_type: string;
  ai_performance_level: string;
  file_processing_type: string;
  overall_processed_status: string;
  visual_processing_status: string;
  rag_processing_status: string;
  overall_processing: {
    time_taken: number;
    status: string;
  };
  document_store?: {
    folder_name?: string;
    document_store_type?: string;
  };
  uploaded_by?: {
    user_name?: string;
  };
  createdAt: string;
}

export interface DocumentProcessReportResponse {
  success: boolean;
  code: number;
  data: {
    documents: DocumentItem[];
    total_count: number;
  };
}

export interface DocumentReportParams {
  skip?: number;
  limit?: number;
  folder_name?: string;
  document_store_type?: string;
}

const documentProcessReportService = {
  getDocumentProcessReport: async (
    params?: DocumentReportParams
  ): Promise<DocumentProcessReportResponse> => {
    const response = await apiClient.post<DocumentProcessReportResponse>(
      API_ENDPOINTS.REPORTS.DOCUMENT_PROCESS_REPORT,
      params
    );
    return response.data;
  },
};

export default documentProcessReportService;
